/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Draftemail_Validation_Torequiredtoschedule5Inputs */

const en_coinvestments_draftemail_validation_torequiredtoschedule5 = /** @type {(inputs: Coinvestments_Draftemail_Validation_Torequiredtoschedule5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add at least one recipient before scheduling`)
};

/**
* | output |
* | --- |
* | "Add at least one recipient before scheduling" |
*
* @param {Coinvestments_Draftemail_Validation_Torequiredtoschedule5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_draftemail_validation_torequiredtoschedule5 = /** @type {((inputs?: Coinvestments_Draftemail_Validation_Torequiredtoschedule5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Draftemail_Validation_Torequiredtoschedule5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_draftemail_validation_torequiredtoschedule5(inputs)
});
export { coinvestments_draftemail_validation_torequiredtoschedule5 as "coInvestments_draftEmail_validation_toRequiredToSchedule" }